













































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { ServerResult } from "@/core/http/server_result";
import { QueryBuilder } from "@/core/uql";
import moment from "moment";
import { timeAsMs } from "@fullcalendar/core/datelib/marker";

@Component
export default class Combobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>;
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop() type!: any;
  @Prop({ type: String }) schema!: string;
  @Prop({ type: String }) scope!: string;
  @Prop({ type: Array }) data!: any[];
  @Prop({ type: String }) keyField!: string;
  @Prop({ type: String }) labelField!: string;
  @Prop({ type: String }) order!: string;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop() labelObject!: any;

  @Prop({ type: String }) relField!: string;
  @Prop({ type: String }) relFilter!: string;
  @Prop({ type: Array }) relFilterIn!: any[];
  @Prop({ type: Array }) relFilters!: any[];
  @Prop({ type: Boolean }) relFilterNull!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;
  @Prop({ type: Boolean }) filterArchived!: boolean;
  @Prop({ type: String }) filterBooleanField!: string;
  @Prop({ type: Boolean, default: true }) filterBooleanValue!: boolean;

  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: Boolean }) clearable!: boolean;
  @Prop({ type: Boolean }) extended!: string;
  @Prop({ type: Function }) prefilter!: Function;
  @Prop({ type: Function }) onLoad!: Function;
  @Prop({ type: Boolean }) wrap!: boolean;
  @Prop({ type: Boolean }) appendToBody!: boolean;
  @Prop({ type: Boolean }) color!: boolean;
  @Prop({ type: Array }) prefilterIn!: any[];
  @Prop({ type: Array }) prefilterNotIn!: any[];
  @Prop({ type: Boolean }) noUpdateAfterLoad!: boolean;
  @Prop({ type: Boolean }) allInner!: boolean;
  @Prop({ type: Boolean }) viewGrouped!: boolean;
  @Prop({ type: Boolean }) viewSecondary!: boolean;

  localValue: any = null;
  selectdItemLabel: any = "";
  selectdItemColor: string = "";
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = "";

  get selectedItemStyle() {
    if (!this.color || !this.selectdItemColor) {
      return {};
    }

    return { background: this.selectdItemColor };
  }

  public created() {
    //
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    if (this.schema) {
      this.loadData();
    } else {
      this.items = this.data;
      if (!this.noUpdateAfterLoad) {
        this.updateValue(this.value);
      }
      this.updateDisplayList();
    }
  }

  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_${this.schema.toUpperCase()}`;

    if (
      this.relField &&
      !(this.relFilter || this.relFilterNull || this.relFilterIn)
    ) {
      return;
    }
    const fields: any = {
      id: `${this.schema}.${this.keyField}`,
      label: this.labelObject
        ? `${this.schema}.${this.labelObject}`
        : `${this.schema}.${this.labelField}`
    };
    if (this.color) {
      fields.color = `${this.schema}.color`;
    }

    const query = this.$q(QNAME)
      .select()
      .fileds(fields)
      .order((_: any) => {
        if (this.order) {
          return [_[this.order]([`${this.schema}.${this.labelField}`])];
        }
        return [_.asc([`${this.schema}.${this.labelField}`])];
      })
      .from(this.schema)
      .where((_: any) => {
        let _filter: any = undefined;
        if (this.relField) {
          if (this.relFilterNull) {
            _filter = _.null([`${this.schema}.${this.relField}`]);
          } else if (this.relFilterIn) {
            _filter = _.in(`${this.schema}.${this.relField}`, {
              $: this.relFilterIn
            });
          } else {
            _filter = _.eq(
              `${this.schema}.${this.relField}`,
              _.const(this.relFilter)
            );
          }
        }
        if (this.relFilters) {
          const _filters = this.relFilters.map((filter: any) => {
            const op = Object.keys(filter)[0];
            return _[op.replace("$", "")](
              `${this.schema}.${filter[op][0]}`,
              _.const(filter[op][1])
            );
          });
          if (_filter) {
            _filter = _.and([_filter, ..._filters]);
          } else {
            _filter = _.and(_filters);
          }
        }
        return _filter;
      })
      .limit(100000);

    switch (this.scope) {
      case "drivers": {
        query.innerJoin("employee_vehicles", (_: any) => {
          return _.eq("employee_vehicles.employee_id", "employees.id");
        });

        break;
      }
      case "linked": {
        query.innerJoin("departments", (_: any) => {
          return _.eq("departments.id", "employees.department_id");
        });

        break;
      }
    }

    switch (this.schema) {
      case "clients": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: this.labelObject
            ? `${this.schema}.${this.labelObject}`
            : `${this.schema}.${this.labelField}`,
          payment_type_id: `${this.schema}.payment_type_id`,
          delivery_warehouse_id: `${this.schema}.delivery_warehouse_id`,
          destination_warehouse_id: `${this.schema}.destination_warehouse_id`,
          manager_id: `${this.schema}.manager_id`,
          type_id: `${this.schema}.type_id`,
          deal_comment: `${this.schema}.deal_comment`,
          special_orders: `${this.schema}.special_orders`
        });

        break;
      }
      case "delivery_zones": {
        if (this.viewGrouped) {
          query
            .fileds({
              id: "delivery_zone_groups.id",
              label: "delivery_zone_groups.name",
              items: {
                $array_agg: {
                  $obj: {
                    id: "delivery_zones.id",
                    label: "delivery_zones.name"
                  }
                }
              }
            })
            .innerJoin("delivery_zone_groups", (_: any) => {
              return _.eq(
                "delivery_zone_groups.id",
                "delivery_zones.delivery_zone_group_id"
              );
            })
            .group(["delivery_zone_groups.id", "delivery_zone_groups.name"])
            .order((_: any) => {
              return [_.asc([`delivery_zone_groups.name`])];
            });
        } else {
          query
            .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: {
                $concat: [
                  "delivery_zones.name",
                  { $: " (" },
                  "delivery_zone_groups.name",
                  { $: ")" }
                ]
              }
            })
            .innerJoin("delivery_zone_groups", (_: any) => {
              return _.eq(
                "delivery_zone_groups.id",
                "delivery_zones.delivery_zone_group_id"
              );
            });
        }

        break;
      }
      case "delivery_points": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: this.labelObject
              ? `${this.schema}.${this.labelObject}`
              : `${this.schema}.${this.labelField}`,
            label_secondary: "clients.name",
            delivery_delay: "delivery_zone_groups.delivery_delay",
            archived_at: `${this.schema}.archived_at`,
            counterparty_id: `${this.schema}.counterparty_id`,
            delivery_zone_id: `delivery_zones.id`,
            days: {
              $array_agg: {
                $obj: {
                  week_day: "delivery_date_schedule.week_day",
                  is_allow: "delivery_date_schedule.is_allow",
                  time: "delivery_date_schedule.time",
                  delivery_point_id: "delivery_date_schedule.delivery_point_id"
                }
              }
            }
          })
          .innerJoin("delivery_points_delivery_zones", (_: any) => {
            return _.eq(
              "delivery_points_delivery_zones.delivery_point_id",
              "delivery_points.id"
            );
          })
          .innerJoin("delivery_zones", (_: any) => {
            return _.eq(
              "delivery_zones.id",
              "delivery_points_delivery_zones.delivery_zone_id"
            );
          })
          .innerJoin("delivery_zone_groups", (_: any) => {
            return _.eq(
              "delivery_zone_groups.id",
              "delivery_zones.delivery_zone_group_id"
            );
          })
          .innerJoin("clients", (_: any) => {
            return _.eq("clients.id", "delivery_points.client_id");
          })
          .leftJoin("delivery_date_schedule", (_: any) => {
            return _.or([
              _.and([
                _.eq(
                  "delivery_date_schedule.delivery_zone_id",
                  "delivery_zones.id"
                ),
                _.null(["delivery_date_schedule.delivery_point_id"])
              ]),
              _.eq(
                "delivery_date_schedule.delivery_point_id",
                "delivery_points.id"
              )
            ]);
          })
          .group([
            `${this.schema}.${this.keyField}`,
            this.labelObject
              ? `${this.schema}.${this.labelObject}`
              : `${this.schema}.${this.labelField}`,
            "clients.name",
            "delivery_zone_groups.delivery_delay",
            `${this.schema}.archived_at`,
            `${this.schema}.counterparty_id`,
            `delivery_zones.id`
          ]);
        if (this.relField == "delivery_zone_id") {
          query.where((_: any) => {
            return _.eq(`delivery_zones.id`, _.const(this.relFilter));
          });
        }

        break;
      }
      case "deals": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: "delivery_points.address",
            label_secondary: "deals.name",
            deal_date: "deals.expected_delivery_date",
            client_id: "deals.client_id"
          })
          .leftJoin("delivery_points", (_: any) => {
            return _.eq("delivery_points.id", "deals.delivery_point_id");
          });

        break;
      }
      case "produced_products": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: "produced_products.name",
            base_name: "voc_bases.name",
            butter: "produced_products.butter",
            strach: "produced_products.strach",
            strach_b152: "produced_products.strach_b152",
            strach_purity87: "produced_products.strach_purity87",
            strach_add: "produced_products.strach_add",
            cream: "produced_products.cream",
            mozarella: "produced_products.mozarella",
            scp: "produced_products.scp",
            tara: "produced_products.tara",
            ksatan: "produced_products.ksatan",
            ap35: "produced_products.ap35",
            salt: "produced_products.salt",
            sugar: "produced_products.sugar",
            sorbat: "produced_products.sorbat",
            nizin: "produced_products.nizin",
            remainders: "produced_products.remainders",
            ingredients: {
              $array_agg: {
                $obj: {
                  name: "voc_ingredients.name",
                  type: "voc_ingredients.type",
                  code: "voc_ingredients.code",
                  value_time_1: "produced_product_ingredients.value_time_1",
                  value_time_2: "produced_product_ingredients.value_time_2",
                  value_time_3: "produced_product_ingredients.value_time_3",
                  value_time_4: "produced_product_ingredients.value_time_4",
                  value_time_5: "produced_product_ingredients.value_time_5",
                  value_time_6: "produced_product_ingredients.value_time_6",
                  value_time_7: "produced_product_ingredients.value_time_7"
                }
              }
            }
          })
          .leftJoin("voc_bases", (_: any) => {
            return _.eq("voc_bases.id", "produced_products.base_id");
          })
          .innerJoin("produced_product_ingredients", (_: any) => {
            return _.eq(
              "produced_product_ingredients.produced_product_id",
              "produced_products.id"
            );
          })
          .innerJoin("voc_ingredients", (_: any) => {
            return _.eq(
              "produced_product_ingredients.ingredient_id",
              "voc_ingredients.id"
            );
          })
          .group([
            `${this.schema}.${this.keyField}`,
            "produced_products.name",
            "voc_bases.name",
            "produced_products.butter",
            "produced_products.strach",
            "produced_products.strach_b152",
            "produced_products.strach_purity87",
            "produced_products.strach_add",
            "produced_products.cream",
            "produced_products.mozarella",
            "produced_products.scp",
            "produced_products.tara",
            "produced_products.ksatan",
            "produced_products.ap35",
            "produced_products.salt",
            "produced_products.sugar",
            "produced_products.sorbat",
            "produced_products.nizin",
            "produced_products.remainders"
          ]);
        break;
      }
      case "counterparties": {
        if (this.extended) {
          query
            .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: {
                $concat: [
                  this.labelObject
                    ? `${this.schema}.${this.labelObject}`
                    : `${this.schema}.${this.labelField}`,
                  { $: " (" },
                  "delivery_points.address",
                  { $: ")" }
                ]
              },
              delivery_point_id: "delivery_points.id"
            })
            .leftJoin("delivery_points", (_: any) => {
              return _.and([
                _.eq("delivery_points.counterparty_id", "counterparties.id"),
                _.null(["delivery_points.archived_at"])
              ]);
            });
        } else {
          query.fileds({
            id: `${this.schema}.${this.keyField}`,
            label: this.labelObject
              ? `${this.schema}.${this.labelObject}`
              : `${this.schema}.${this.labelField}`
          });
        }
        break;
      }
      case "shift_templates": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: this.labelObject
            ? `${this.schema}.${this.labelObject}`
            : `${this.schema}.${this.labelField}`,
          text: `${this.schema}.text`
        });
        break;
      }
      case "vehicles": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: {
            $concat: [
              "vehicles.model",
              { $: " (" },
              "vehicles.number",
              { $: ")" }
            ]
          }
        });
        break;
      }
      case "voc_starter_types": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: this.labelObject
            ? `${this.schema}.${this.labelObject}`
            : `${this.schema}.${this.labelField}`,
          activity_id: `${this.schema}.activity_id`,
          rotate_ids: `${this.schema}.rotate_ids`,
          starter_type: `${this.schema}.starter_type`
        });
        break;
      }
      case "warehouse_internal_remains": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: {
              $concat: [
                `voc_bases.name`,
                { $: " (" },
                "voc_containers.name",
                { $: ")" }
              ]
            },
            date: `warehouse_internal_remains.created_at`,
            base_id: `voc_bases.id`
          })
          .leftJoin("voc_bases", (_: any) => {
            return _.and([
              _.eq("voc_bases.id", "warehouse_internal_remains.base_id")
            ]);
          })
          .leftJoin("voc_containers", (_: any) => {
            return _.and([
              _.eq(
                "voc_containers.id",
                "warehouse_internal_remains.container_id"
              )
            ]);
          })
          .order((_: any) => {
            return [_.asc([`voc_bases.name`])];
          });
        break;
      }
      case "voc_base_activity": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: {
              $concat: [
                "voc_base_activity.liter",
                { $: " (" },
                "voc_base_activity.by_producer",
                { $: ")" }
              ]
            }
          })
          .order((_: any) => {
            return [_.asc([`voc_base_activity.id`])];
          });
        break;
      }
      case "product_containers": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: this.labelObject
            ? `${this.schema}.${this.labelObject}`
            : `${this.schema}.${this.labelField}`,
          name: `${this.schema}.name`,
          position: `${this.schema}.position`,
          weight: `${this.schema}.weight`,
          volume: `${this.schema}.volume`,
          price: `${this.schema}.price`,
          is_sample: `${this.schema}.is_sample`,
          barcode: `${this.schema}.barcode`,
          sku: `${this.schema}.sku`,
          price_per_kg: `${this.schema}.price_per_kg`
        });
        break;
      }
      case "voc_containers": {
        query.fileds({
          id: `${this.schema}.${this.keyField}`,
          label: `${this.schema}.${this.labelField}`,
          weight: "voc_containers.weight",
          tare_weight: "voc_containers.tare_weight",
          row_count: "voc_containers.row_count",
          bucket_count: "voc_containers.bucket_count"
        });
        break;
      }
      case "shift_atom_coock_plan_items": {
        query
          .fileds({
            label: {
              $concat: [
                "shift_atom_coock_plan.number",
                { $: " (" },
                "produced_products.name",
                { $: ")" }
              ]
            },
            items: {
              $array_agg: {
                $obj: {
                  id: "shift_atom_coock_plan_items.id",
                  label: "shift_plan_vdp.number",
                  date: "shifts.shift_date"
                }
              }
            }
          })
          .innerJoin("shift_atom_coock_plan", (_: any) => {
            return _.eq(
              "shift_atom_coock_plan.id",
              "shift_atom_coock_plan_items.coock_plan_id"
            );
          })
          .innerJoin("shift_plan_vdp", (_: any) => {
            return _.eq(
              "shift_plan_vdp.id",
              "shift_atom_coock_plan_items.vdp_plan_id"
            );
          })
          .innerJoin("shifts", (_: any) => {
            return _.eq("shifts.id", "shift_plan_vdp.shift_id");
          })
          .innerJoin("produced_products", (_: any) => {
            return _.eq(
              "produced_products.id",
              "shift_atom_coock_plan.product_id"
            );
          })
          .where((_: any) => {
            if (this.relField) {
              if (this.relFilterNull) {
                return _.null([`shift_atom_coock_plan.${this.relField}`]);
              } else {
                return _.eq(
                  `shift_atom_coock_plan.${this.relField}`,
                  _.const(this.relFilter)
                );
              }
            } else {
              return undefined;
            }
          })
          .group([
            "shift_atom_coock_plan.id",
            "produced_products.name",
            "shift_atom_coock_plan.number"
          ])
          .order((_: any) => {
            return [_.asc([`produced_products.name`])];
          });
        break;
      }
      case "shift_atom_coock_plan": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: {
              $concat: [
                "shift_atom_coock_plan.number",
                { $: " (" },
                "produced_products.name",
                { $: ")" }
              ]
            },
            number: "shift_atom_coock_plan.number",
            recast: "shift_journal_atom.recast",
            recast_weight: "voc_containers.weight",
            clots_weight: "shift_journal_atom.clots_weight",
            sum_ingredients: { $sum: "shift_journal_atom_ingredients.value" }
          })
          .innerJoin("produced_products", (_: any) => {
            return _.eq(
              "produced_products.id",
              "shift_atom_coock_plan.product_id"
            );
          })
          .leftJoin("shift_journal_atom", (_: any) => {
            return _.eq(
              "shift_journal_atom.plan_id",
              "shift_atom_coock_plan.id"
            );
          })
          .leftJoin("shift_journal_atom_ingredients", (_: any) => {
            return _.eq(
              "shift_journal_atom_ingredients.journal_id",
              "shift_journal_atom.id"
            );
          })
          .leftJoin("voc_containers", (_: any) => {
            return _.eq(
              "voc_containers.id",
              "shift_journal_atom.recast_container_id"
            );
          })
          .group([
            `${this.schema}.${this.keyField}`,
            "produced_products.name",
            "shift_atom_coock_plan.number",
            {
              $concat: [
                "shift_atom_coock_plan.number",
                { $: " (" },
                "produced_products.name",
                { $: ")" }
              ]
            },
            "shift_atom_coock_plan.number",
            "shift_journal_atom.recast",
            "shift_journal_atom.clots_weight",
            "voc_containers.weight"
          ])
          .order((_: any) => {
            return [_.asc([`produced_products.name`])];
          });
        break;
      }
      case "shift_plan_vdp": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: {
              $concat: [
                { $: "партия " },
                "shift_plan_vdp.number",
                { $: " - " },
                "voc_bases.name"
              ]
            },
            container_id: "voc_containers.id",
            row_count: "voc_containers.row_count",
            bucket_count: "voc_containers.bucket_count",
            date: "shifts.shift_date",
            times_of_day: "shifts.times_of_day",
            starter_type_code: "voc_starter_types.starter_type",
            base_id: `${this.schema}.base_id`,
            warehouse_internal_remains_id: `warehouse_internal_remains.id`,
            mark_no_incident: "view_base_mark.no_incident",
            mark_water_state: "view_base_mark.water_state",
            mark_no_fat: "view_base_mark.no_fat",
            mark_normal_acidity: "view_base_mark.normal_acidity",
            comment: "shift_fact_vdp.comment",
            warehouse_remains: "view_warehouse_internal_remains.remains"
          })
          .innerJoin("voc_bases", (_: any) => {
            return _.eq("shift_plan_vdp.base_id", "voc_bases.id");
          })
          .innerJoin("shifts", (_: any) => {
            return _.eq("shifts.id", "shift_plan_vdp.shift_id");
          })
          .innerJoin("voc_starter_types", (_: any) => {
            return _.eq(
              "voc_starter_types.id",
              "shift_plan_vdp.starter_type_id"
            );
          });
        if (this.allInner) {
          query
            .innerJoin("shift_fact_vdp", (_: any) => {
              return _.eq("shift_plan_vdp.id", "shift_fact_vdp.shift_plan_id");
            })
            .innerJoin("warehouse_internal_remains", (_: any) => {
              return _.eq(
                "warehouse_internal_remains.fact_id",
                "shift_fact_vdp.id"
              );
            })
            .innerJoin("voc_containers", (_: any) => {
              return _.eq("voc_containers.id", "shift_fact_vdp.container_id");
            })
            .innerJoin("view_base_mark", (_: any) => {
              return _.eq("view_base_mark.id", "shift_fact_vdp.id");
            })
            .innerJoin("view_warehouse_internal_remains", (_: any) => {
              return _.eq(
                "view_warehouse_internal_remains.vdp_plan_id",
                "shift_plan_vdp.id"
              );
            });
        } else {
          query
            .leftJoin("shift_fact_vdp", (_: any) => {
              return _.eq("shift_plan_vdp.id", "shift_fact_vdp.shift_plan_id");
            })
            .leftJoin("warehouse_internal_remains", (_: any) => {
              return _.eq(
                "warehouse_internal_remains.fact_id",
                "shift_fact_vdp.id"
              );
            })
            .leftJoin("voc_containers", (_: any) => {
              return _.eq("voc_containers.id", "shift_fact_vdp.container_id");
            })
            .leftJoin("view_base_mark", (_: any) => {
              return _.eq("view_base_mark.id", "shift_fact_vdp.id");
            })
            .leftJoin("view_warehouse_internal_remains", (_: any) => {
              return _.eq(
                "view_warehouse_internal_remains.vdp_fact_id",
                "shift_fact_vdp.id"
              );
            });
        }
        query
          .order((_: any) => {
            return [_.asc([`shift_plan_vdp.id`])];
          })
          .group([
            `${this.schema}.${this.keyField}`,
            "voc_containers.id",
            "voc_containers.row_count",
            "voc_containers.bucket_count",
            "shifts.shift_date",
            "shifts.times_of_day",
            "voc_starter_types.starter_type",
            `${this.schema}.base_id`,
            "warehouse_internal_remains.id",
            "voc_bases.name",
            "view_base_mark.no_incident",
            "view_base_mark.water_state",
            "view_base_mark.no_fat",
            "view_base_mark.normal_acidity",
            "shift_fact_vdp.comment",
            "view_warehouse_internal_remains.remains"
          ]);
        break;
      }
      case "shift_fact_vdp": {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: "voc_bases.name",
            quantity: "shift_fact_vdp.quantity",
            weight_neto: "shift_fact_vdp.weight_neto"
          })
          .innerJoin("shift_plan_vdp", (_: any) => {
            return _.eq("shift_plan_vdp.id", "shift_fact_vdp.shift_plan_id");
          })
          .innerJoin("voc_bases", (_: any) => {
            return _.eq("shift_plan_vdp.base_id", "voc_bases.id");
          })
          .where((_: any) => {
            if (this.relField) {
              if (this.relFilterNull) {
                return _.null([`shift_plan_vdp.${this.relField}`]);
              } else {
                return _.eq(
                  `shift_plan_vdp.${this.relField}`,
                  _.const(this.relFilter)
                );
              }
            } else {
              return undefined;
            }
          })
          .order((_: any) => {
            return [_.asc([`shift_fact_vdp.id`])];
          });
        break;
      }
      case "voc_causticities": {
        query
          .innerJoin("voc_starter_types", (_: any) => {
            return _.eq(
              "voc_starter_types.id",
              "voc_causticities.starter_type_id"
            );
          })
          .where((_: any) => {
            if (this.relField == "starter_type_id") {
              if (this.relFilterNull) {
                return _.null([`voc_causticities.${this.relField}`]);
              } else {
                return _.eq(
                  `voc_starter_types.starter_type`,
                  _.const(this.relFilter)
                );
              }
            } else {
              return undefined;
            }
          });
        break;
      }
      case "voc_characteristic": {
        query
          .innerJoin("voc_starter_types", (_: any) => {
            return _.eq(
              "voc_starter_types.id",
              "voc_characteristic.starter_type_id"
            );
          })
          .where((_: any) => {
            if (this.relField == "starter_type_id") {
              if (this.relFilterNull) {
                return _.null([`voc_characteristic.${this.relField}`]);
              } else {
                return _.eq(
                  `voc_starter_types.starter_type`,
                  _.const(this.relFilter)
                );
              }
            } else {
              return undefined;
            }
          });
        break;
      }
    }

    // опциональный фильтр по boolean-полю той же схемы (например,
    // products.is_semifinished = true для выбора полуфабрикатов)
    if (this.filterBooleanField) {
      query.where((_: any) => {
        return _.eq(
          `${this.schema}.${this.filterBooleanField}`,
          _.const(this.filterBooleanValue)
        );
      });
    }

    if (this.filterArchived) {
      if (this.schema == "employees") {
        // @ts-ignore
        query.columnMap.archived_at = `${this.schema}.fired_at`;
      } else {
        // @ts-ignore
        query.columnMap.archived_at = `${this.schema}.archived_at`;
      }
    }

    this.$db([query]).then((result: ServerResult) => {
      this.items = result
        .getOperation(QNAME)
        .getContent()
        .documents.map((item: any) => {
          if (this.schema == "shift_plan_vdp") {
            item.tag_type =
              item.mark_no_incident &&
              item.mark_water_state == "ok" &&
              item.mark_no_fat &&
              item.mark_normal_acidity
                ? "is-success"
                : "is-danger";
          }
          return item;
        });
      if (this.onLoad) {
        this.onLoad(this.items);
      }
      const event = this.noUpdateAfterLoad
        ? this.onValueChange
        : this.updateValue;
      if (this.multiple && !Array.isArray(this.value)) {
        event([this.value]);
        this.updateValueAllways([this.value]);
      } else {
        event(this.value);
        this.updateValueAllways(this.value);
      }
      this.updateDisplayList();
    });
  }

  @Watch("value")
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    const items = this.items.reduce((prev: any[], item) => {
      if (item.items) {
        item.items.map((i: any) => {
          prev.push(i);
        });
      }
      prev.push(item);
      return prev;
    }, []);
    // console.log('items', items);

    if (this.localValue) {
      if (Array.isArray(this.localValue)) {
        const selectdItems = items.filter(item =>
          this.localValue.includes(item.id)
        );

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems
            .map(item => item.label)
            .join(", ");
          this.selectdItemColor = "";
        } else {
          this.selectdItemLabel = "";
          this.selectdItemColor = "";
        }
      } else {
        const selectdItem = items.find(item => item.id == this.localValue);

        if (selectdItem) {
          let _suffix = "";
          if (selectdItem.date) {
            _suffix = " (" + moment(selectdItem.date).format("DD.MM.YYYY");
            if (selectdItem.times_of_day) {
              _suffix +=
                " " + (selectdItem.times_of_day == "day" ? "день" : "ночь");
            }
            _suffix += ")";
          }
          this.selectdItemLabel = selectdItem.label + _suffix;
          this.selectdItemColor =
            this.color && selectdItem.color ? selectdItem.color : "";
        } else {
          this.selectdItemLabel = "";
          this.selectdItemColor = "";
        }
      }
    } else {
      this.selectdItemLabel = "";
      this.selectdItemColor = "";
    }
  }

  @Watch("relFilter")
  onRelFilterChange(newVal: any) {
    this.updateValue(null);
    this.loadData();
  }

  updateValue(value: any) {
    this.onValueChange(value);

    if (Array.isArray(this.localValue)) {
      this.$emit(
        "input",
        value.filter((item: any) => item)
      );
      const selectdItems = this.items.filter(item =>
        this.localValue.includes(item.id)
      );

      this.$emit("input-object", selectdItems);
      this.$emit("input-native", selectdItems);
    } else {
      this.$emit("input", value);
      const selectdItem = this.items.find(item => item.id == this.localValue);

      this.$emit("input-object", selectdItem);
      this.$emit("input-native", selectdItem);
    }
  }
  updateValueAllways(value: any) {
    this.onValueChange(value);

    if (Array.isArray(this.localValue)) {
      const selectdItems = this.items.filter(item =>
        this.localValue.includes(item.id)
      );

      this.$emit("input-allways", selectdItems);
    } else {
      const selectdItem = this.items.find(item => item.id == this.localValue);

      this.$emit("input-allways", selectdItem);
    }
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + "px";
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width =
      width - 25 + "px";
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus();
    }
  }

  @Watch("prefilterIn")
  watchPrefilterIn() {
    this.updateDisplayList();
  }

  @Watch("prefilterNotIn")
  watchPrefilteNotrIn() {
    this.updateDisplayList();
  }

  @Watch("searchText")
  updateDisplayList() {
    const searchText = this.searchText ? this.searchText.toLowerCase() : "";
    let items = this.items || [];
    if (this.prefilter) {
      items = items.filter((item: any, index: number) => {
        return this.prefilter(item, index);
      });
    }
    if (this.prefilterIn && this.prefilterIn.length > 0) {
      items = items.filter((item: any, index: number) => {
        return this.prefilterIn.includes(item[this.keyField]);
      });
    }
    if (this.prefilterNotIn && this.prefilterNotIn.length > 0) {
      items = items.filter((item: any, index: number) => {
        return !this.prefilterNotIn.includes(item[this.keyField]);
      });
    }
    this.$set(
      this,
      "itemsForDisplay",
      items.filter((item: any) => {
        if (this.filterArchived) {
          return !item.archived_at
            ? (item.label || "").toLowerCase().includes(searchText)
            : null;
        } else {
          return (
            (item.label || "").toLowerCase().includes(searchText) ||
            (item.label_secondary || "").toLowerCase().includes(searchText)
          );
        }
      })
    );
  }

  clear() {
    this.updateValue(null);
  }

  // search($event) {
  //   throttle
  // }
}
